import React, { Fragment } from 'react';
import Show404Page from '../components/sections/errorPage/Show404Page';

export default function Show404() {
    return (
        <Fragment>
            <div className='container'>
                <Show404Page />
            </div>
        </Fragment>
    )
}